export default __webpack_public_path__ + "static/media/QMark.d4988b6e.svg";